import React, { useState } from 'react';

import { NavbarWrapper } from './styles';

import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';

import { FaRegListAlt } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';


function Navbar() {

    const [open, setOpen] = useState(false);

    function handleOpen() {
        if (open) {
            document.getElementById('navbar').style.width = '0px';
            setOpen(false);
        } else {
            document.getElementById('navbar').style.width = '200px';
            setOpen(true);
        }
    }

    function handleClose() {
        document.getElementById('navbar').style.width = '0px';
        setOpen(false);
    }

    return (
        <NavbarWrapper>
            <figure>
                <Link to="/">
                    <img src={logo} alt="" />
                </Link>
            <FaRegListAlt className="dropdown" size={30} color={'var(--orange)'} onClick={() => handleOpen()} />
            </figure>

            
            <ul>
                <li><Link to="">Home</Link></li>
                <li><Link to="">About</Link></li>
                <li><Link to="">Services</Link></li>
                <li><Link to="">Blog</Link></li>
                <li><Link to="">Contact</Link></li>
                <li><Link to="">Free Quote</Link></li>
            </ul>

            <ul id="navbar">
                <li><MdClose className="close" size={30} color={'var(--orange)'} onClick={() => handleClose()} /></li>
                <li><Link to="" onClick={() => handleClose()}>Home</Link></li>
                <li><Link to="" onClick={() => handleClose()}>About</Link></li>
                <li><Link to="" onClick={() => handleClose()}>Services</Link></li>
                <li><Link to="" onClick={() => handleClose()}>Blog</Link></li>
                <li><Link to="" onClick={() => handleClose()}>Contact</Link></li>
                <li><Link to="" onClick={() => handleClose()}>Free Quote</Link></li>
            </ul>

        </NavbarWrapper>
    );
}

export default Navbar;